import Modal from '../Modal/Modal';
import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Styled';

const propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  instruction: PropTypes.string,
};

const Instruction = ({ visible, setVisible, instruction, ...props }) => {
  return (
    <Modal
      visible={visible}
      onOk={() => {
        setVisible(false);
      }}
      onCancel={() => {
        setVisible(false);
      }}
      width={936}
      {...props}
    >
      <S.Container dangerouslySetInnerHTML={{ __html: instruction }} />
    </Modal>
  );
};

Instruction.propTypes = propTypes;

export default Instruction;
